

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as weixin from '@ivy/fts/weixin'
import { uploadEvent } from '@/api/goods/statistics'

@Component({
  components: {},
})
export default class Preview extends Vue {
  levels: any = [
    {
      id: 'YLE_Starters',
      text: 'YLE_Starters',
      name: 'Pre A1 Starters',
    },
    {
      id: 'YLE_Movers',
      text: 'YLE_Movers',
      name: 'A1 Movers',
    },
    {
      id: 'YLE_Flyers',
      text: 'YLE_Flyers',
      name: 'A2 Flyers',
    },
    {
      id: 'KET',
      text: 'KET',
      name: 'A2',
    },
    {
      id: 'PET',
      text: 'PET',
      name: 'B1',
    },
  ]
  curIndex: number = null
  curName: string = 'Pre A1 Starters'
  markEl: any = null
  async mounted() {
    this.$title('测试分级')
    // let markEl = document.querySelector('.mark-box')
    // console.log('markEl', markEl)
    // this.markEl = markEl
    await env.init()
    this.loadInfo()
  }
  async loadInfo() {
    let { data } = await this.$axios.get('/api/mobile/app/road_map/ket')
    this.setShare(data.share_data)
    let curItem =
      data.level_group.find(item => item.level === data.userLevel) || {}
    this.curName = curItem.level || this.curName
    let idx = data.level_group
      .filter(item => item.level !== 'Zero Based')
      .findIndex(item => item.level === data.userLevel)
    this.curIndex = Math.max(idx, 0)
  }
  async setShare(config) {
    if (env.type === 'ivydad') {
      await env.init()
      await env.shareInfo(config)
    } else {
      await weixin.weixinShare({
        title: config.title,
        desc: config.content,
        imgUrl: config.pic_url,
        link: config.url,
      })
    }
  }
  switchItem(idx) {
    this.curIndex = idx
    // let height = this.markEl.offsetHeight
    // this.markEl.style.top = idx * height + 'px'
    // const self = this
    // setTimeout(() => {
    //   self.curName = self.levels[idx].name
    // }, 150)
    // this.levels = this.levels.map((item, index) => {
    //   return {
    //     ...item,
    //     checked: index === idx,
    //   }
    // })
  }
  async goText() {
    let url = 'https://www.cambridgeenglish.org/test-your-english/'
    await env.init()
    if (env.type === 'ivydad') {
      env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}`)
    } else {
      window.location.href = url
    }
  }
  async confirm() {
    await env.init()
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
    try {
      await uploadEvent.init()
      await uploadEvent.addStatistics({
        event_type: 'Click_KETTest_ConfirmButton',
      })
    } catch (e) {
      console.error(e)
    }
    await this.$axios.post('/api/mobile/app/road_map/saveEvaluationResult', {
      standard: 'MSE',
      result: this.levels[this.curIndex]['name'],
    })
    if (env.type === 'ivydad') {
      env.nativeCall({
        method: 'refreshKet',
        data: {},
      })
      env.back()
    } else {
      this.$router.push({
        path: 'ket-line',
      })
    }
  }
}
